/** @internal */
export const OP_CONTINUATION_K = "ContinuationK" as const

/** @internal */
export type OP_CONTINUATION_K = typeof OP_CONTINUATION_K

/** @internal */
export const OP_CONTINUATION_FINALIZER = "ContinuationFinalizer" as const

/** @internal */
export type OP_CONTINUATION_FINALIZER = typeof OP_CONTINUATION_FINALIZER
